import React from 'react';

export default () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.3125 2V5.75L2 5.75V2L12.3125 2ZM8.5625 13.25L8.5625 17H2L2 13.25L8.5625 13.25ZM17 7.625V11.375L2 11.375V7.625L17 7.625Z" fill="currentColor" />
  </svg>
);
